import { render, staticRenderFns } from "./AppointmentSlot.vue?vue&type=template&id=60afaaa1&scoped=true"
import script from "./AppointmentSlot.vue?vue&type=script&lang=js"
export * from "./AppointmentSlot.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSlot.vue?vue&type=style&index=0&id=60afaaa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afaaa1",
  null
  
)

export default component.exports